import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';
import { notify } from 'src/components/notify';

const updateCampianGroup = async (user, data,id) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: `/service/accounts_service/v1/accounts/wa/number/group/${id}`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            data
        };
        const response = await axios.request(config);
        return response.data;
    } catch (err) {
        console.log(err);
        return notify(err?.message)

    }
};

export default updateCampianGroup;
